export default __webpack_public_path__ + "static/media/table-arrow-right.1d1022ca.svg";